import React, { useRef, useState, useCallback } from "react";
import "./barcodeSearch.scss";
import { FiSearch } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { MdQrCodeScanner } from "react-icons/md";
import { BarcodeSearchProps } from "./interface";
import { Html5Qrcode } from "html5-qrcode";

const Index = ({
  searchCallBack,
  placeholder,
  className,
  isClearable = false,
  searchValueLength = 6,
}: BarcodeSearchProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const scannerRef = useRef<any>(null);

  const [showScanner, setShowScanner] = useState(false);
  const [value, setValue] = useState("");
  
  const handleSubmit = (e: any) => {
    e.preventDefault();

    const trimmed = value.replace(/\s/g, "");
    if (trimmed.length >= 1) {
      searchCallBack(trimmed?.toUpperCase());

      if (isClearable) {
        setValue("");
        if (inputRef.current) inputRef.current.value = "";
      }
    }
  };

  const clearInput = () => {
    setValue("");
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.focus();
    }
  };

  const openScanner = () => setShowScanner(true);

  const initScanner = useCallback(async (node: HTMLDivElement | null) => {
    if (!node) return;
  
    const html5QrCode = new Html5Qrcode("barcode-reader");
  
    // Get all cameras
    const devices = await Html5Qrcode.getCameras();
  
    if (!devices || devices.length === 0) {
      console.log("No cameras found");
      return;
    }
  
    // Try to pick the BACK camera
    const backCamera = devices.find((d) =>
      d.label.toLowerCase().includes("back")
    );
  
    const cameraId = backCamera ? backCamera.id : devices[0].id;
  
    html5QrCode
      .start(
        cameraId,
        {
          fps: 10,
          qrbox: { width: 250, height: 75 },
        },
        (decodedText) => {
          if (inputRef.current) inputRef.current.value = decodedText;
          searchCallBack(decodedText?.toUpperCase());
          setValue(decodedText);
        },
        (error) => console.log("Scan error:", error)
      )
      .catch((err) => console.log("Unable to start scanning", err));
  
    scannerRef.current = html5QrCode;
  }, []);
  

  const closeScanner = () => {
    setShowScanner(false);
  
    if (scannerRef.current) {
      scannerRef.current.stop().then(() => {
        scannerRef.current.clear();
        scannerRef.current = null;
      });
    }
  };
  

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="position-relative">
          <span className="position-absolute search-icon">
            <FiSearch />
          </span>

          <input
            ref={inputRef}
            className={[className, "barcode-search"].join(" ")}
            autoComplete="off"
            type="text"
            name="keyword"
            placeholder={placeholder || "Search"}
            // maxLength={6}
            onChange={(e) => setValue(e.target.value)}
          />

          {value !== "" && (
            <button
              type="button"
              className="barcode-clear-btn"
              onClick={clearInput}
            >
              <RxCross2 />
            </button>
          )}

          <button
            type="button"
            className="barcode-scan-btn hide-barcode-scanner-icon"
            onClick={openScanner}
          >
            <MdQrCodeScanner />
          </button>
        </div>
      </form>

      {showScanner && (
        <div className="scanner-modal hide-barcode-scanner-icon">
          <div
            id="barcode-reader"
            ref={initScanner}
            style={{ width: "100%" }}
          ></div>

          <button type="button" onClick={closeScanner}>
            Close
          </button>
        </div>
      )}
    </>
  );
};

export default Index;
